module.exports = __webpack_public_path__ + "img/collection-memoireRingsColored.a50b8fa.webp";